module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "author"
  }, [_vm._v("9")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('span', [_vm._v("Narr")]), _vm._v(", der du suchst,\ndich auf eignen"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nSchultern zu tragen; o Bettler, der du"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nkommst, an eignen Türen zu betteln!")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Leg deine Lasten in seine Hände, der"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nalles trägt und schaue nicht zurück in"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nBedauern.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Deine Begierde löschet sogleich das"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nLicht der Lampe, die sie mit ihrem Atem"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nberührt. Unheilig ist sie – nimm nicht"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ndeine Gaben aus ihren unreinen Händen."), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nNimm nur, was heilige Liebe dir bietet. "), _c('a', {
    attrs: {
      "id": "page12",
      "title": "rudi49/wedi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a30686d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0010.vue
// module id = 84
// module chunks = 0